import React from 'react';
import { StepButtons } from '../quick/ui';

interface StepContainerProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  onNext: () => void;
  onBack?: () => void;
  isValid?: boolean;
  nextLabel?: string;
}

export const StepContainer: React.FC<StepContainerProps> = ({
  title,
  description,
  children,
  onNext,
  onBack,
  isValid = true,
  nextLabel = "Suivant"
}) => {
  const handleNext = () => {
    if (isValid) {
      onNext();
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold text-primary">{title}</h2>
        {description && (
          <p className="text-neutral-600">{description}</p>
        )}
      </div>

      <div className="space-y-6">
        {children}
      </div>

      <StepButtons
        onNext={handleNext}
        onBack={onBack}
        nextLabel={nextLabel}
        disabled={!isValid}
      />
    </div>
  );
};

export default StepContainer;